import React, { useEffect, useRef } from "react";
import { Loader2 } from "lucide-react";

export const ChatThread = ({ messages, busy, empty, testid }) => {
  const end = useRef(null);
  useEffect(() => { end.current?.scrollIntoView({ block: "end" }); }, [messages, busy]);
  return (
    <div className="flex-1 min-h-0 overflow-y-auto space-y-3 p-4" data-testid={testid}>
      {messages.length === 0 && <p className="text-sm text-emerald-100/60">{empty}</p>}
      {messages.map((m, i) => (
        <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
          <div data-testid={`${testid}-msg-${i}`}
            className={`max-w-[85%] whitespace-pre-wrap rounded-2xl px-3.5 py-2.5 text-sm leading-relaxed ${m.role === "user" ? "bg-gold text-[#0a2e22] rounded-br-sm" : "bg-white/5 border border-gold/20 text-emerald-50 rounded-bl-sm"}`}>
            {m.content || <Loader2 className="w-4 h-4 animate-spin text-gold" />}
          </div>
        </div>
      ))}
      <div ref={end} />
    </div>
  );
};
